export default __webpack_public_path__ + "static/media/nifty_sax_profile.75dc56ef.png";